/** Centralized push / foreground notification configuration. */

export const PUSH_ROUTE_PATHS = {
  PRIORITY_MESSAGES: '/creator/notifications/priority-messages',
};

export const PUSH_CONFIG = {
  DEFAULT_TITLE: 'New notification',
  DEFAULT_LINK: '/activity',
  AUTO_CLOSE_MS: 5500,
  /** Debounce before refetching GET /notifications/count after a push. */
  COUNT_REFRESH_DEBOUNCE_MS: 400,
  /** Re-PATCH fcm-token after the tab was hidden at least this long. */
  IDLE_RESYNC_MS: 10 * 60 * 1000,
  /** Bump when `public/firebase-messaging-sw.js` changes to avoid stale SW caches. */
  SERVICE_WORKER_VERSION: '19',
  TOKEN_SYNC_MAX_RETRIES: 3,
  TOKEN_SYNC_RETRY_BASE_MS: 800,
};

export const FCM_SYNC_REASONS = {
  BOOT: 'boot',
  AUTH: 'auth',
  RESUME: 'resume',
  CONSENT: 'consent',
  PERMISSION: 'permission',
  USER_GESTURE: 'user_gesture',
};

export const PUSH_EVENTS = {
  CONSENT_CHANGED: 'cookieConsentChanged',
};

export const PUSH_SENTRY_TAGS = { area: 'push-notification' };

export const PUSH_SENTRY_STEPS = {
  INITIALIZER_SYNC: 'initializer-sync',
  FOREGROUND_LISTENER: 'foreground-listener',
};
